import React from 'react';
import { createPortal } from 'react-dom';
import stylesClasses from './home.module.scss';
import { HomeIcon, MenuIcon, OrderIcon, RewardsIcon, ScanIcon } from '../../images/svgIcons/svg';
import { NavLink } from 'react-router-dom';
import { ROUTE_FAQ, ROUTE_HOME, ROUTE_MENU, ROUTE_REWARDS_REDEEM, ROUTE_SCAN, VIEW_MORE_RECENT_FAVORITE_ORDER, VIEW_MORE_RECENT_ORDER } from '../../constants';
import { useLocation } from 'react-router';
import { useAppSelector } from '../../redux/store/store';
import { isGuestUser, isIphoneChrome } from '../../helpers/helperMethods';
import { useAuthState } from '../../context/UserAuthentication';
import useCheckMobileScreen from '../../hooks/useCheckMobileScreen';
import { BottomNavTabId, trackBottomNavTabClick } from '../../analytics/pulseClickIds';

const BottomMenu = () => {
  const location = useLocation();
  const isMobile = useCheckMobileScreen();
  const validRewardsLengthFromItemSlice = useAppSelector((state) => state.loyalty.validRewardsCount);
  const { authInfo } = useAuthState();
  const isGuest = isGuestUser(authInfo);
  const portalToBody = isMobile && isIphoneChrome();

  const handleBottomTabClick = (tabId: BottomNavTabId) => {
    trackBottomNavTabClick(tabId, {
      page_path: location.pathname,
    });
  };

  const menu = (
        <div
          className={`${stylesClasses.bottomNavShell} ${
            portalToBody ? 'bottom-nav-body-portal' : ''
          }`}
        >
        <div className={stylesClasses.bottomNav}>
          <NavLink
            to={ROUTE_HOME}
            onClick={() => handleBottomTabClick('home')}
            className={({ isActive }) =>
              `${stylesClasses.navItem} ${isActive ? stylesClasses.active : ""}`
            }
          >
            <HomeIcon />
            <span>home</span>
          </NavLink>
    
          <NavLink
            to={ROUTE_MENU}
            onClick={() => handleBottomTabClick('menu')}
            className={({ isActive }) =>
              `${stylesClasses.navItem} ${isActive ? stylesClasses.active : ""}`
            }
          >
            <MenuIcon />
            <span>menu</span>
          </NavLink>

          <NavLink
            to={VIEW_MORE_RECENT_ORDER}
            onClick={() => handleBottomTabClick('reorder')}
            className={({ isActive }) =>{
              const isManuallyActive = isActive || location.pathname === VIEW_MORE_RECENT_FAVORITE_ORDER;
              return `${stylesClasses.navItem} ${isManuallyActive ? stylesClasses.active : ""}`
            }
            }
          >
            <OrderIcon />
            <span>reorder</span>
          </NavLink>
    
          <NavLink
            to={`${isGuest ? ROUTE_FAQ : ROUTE_REWARDS_REDEEM}`}
            onClick={() => handleBottomTabClick('rewards')}
            className={({ isActive }) =>
              `${stylesClasses.navItem} ${isActive ? stylesClasses.active : ""}`
            }
          >
            <RewardsIcon />
            <span>rewards</span>
            {!!validRewardsLengthFromItemSlice && <span className={stylesClasses.badge}>{validRewardsLengthFromItemSlice ?? 0}</span>}
          </NavLink>
          <NavLink
            to={ROUTE_SCAN}
            onClick={() => handleBottomTabClick('scan')}
            className={({ isActive }) =>
              `${stylesClasses.navItem} ${isActive ? stylesClasses.active : ""}`
            }
          >
            <ScanIcon />
            <span>scan</span>
          </NavLink>
        </div>
        </div>
  );

  return portalToBody ? createPortal(menu, document.body) : menu;
}

export default BottomMenu
